import type { EntityRecord } from "@wedding/schemas";

const statusOrder: Record<string, number> = {
  进行中: 0,
  未开始: 1,
  待确认: 2,
  延期: 3,
  已完成: 4,
  已取消: 5,
};

export function sortTasksByStatus(items: EntityRecord[]) {
  return [...items].sort((left, right) => {
    const leftRank = statusOrder[String(left.data.status ?? "未开始")] ?? 99;
    const rightRank = statusOrder[String(right.data.status ?? "未开始")] ?? 99;
    if (leftRank !== rightRank) return leftRank - rightRank;
    const leftDue = String(left.data.dueDate ?? "9999-12-31");
    const rightDue = String(right.data.dueDate ?? "9999-12-31");
    if (leftDue !== rightDue) return leftDue.localeCompare(rightDue);
    return String(left.data.title ?? "").localeCompare(
      String(right.data.title ?? ""),
      "zh-CN",
    );
  });
}

export function taskOwners(items: EntityRecord[]) {
  return [
    ...new Set(
      items.map((item) => String(item.data.owner ?? "").trim()).filter(Boolean),
    ),
  ].sort((left, right) => left.localeCompare(right, "zh-CN"));
}
